export default __webpack_public_path__ + "static/media/landing-page-banner.07b59a9e.jpg";